"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var MediaManagerImage_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/MediaManagerImage"));

var polished_1 = require("polished");

var prop_types_1 = tslib_1.__importDefault(require("prop-types"));

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var propTypes_1 = require("../../propTypes");

var utilities_1 = require("../../utilities");

var titleLinkClass = 'articlelist-listitem-title';
var pictureLinkClass = 'articlelist-listitem-picture';
var PICTURE_WIDTH = 87;
var PICTURE_HEIGHT = utilities_1.calculatePictureHeight(PICTURE_WIDTH, 4, 3);
var Wrapper = styled_components_1["default"]('article')(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  font-size: ", ";\n\n  .", " {\n    flex-shrink: 0;\n    flex-basis: ", "px;\n    margin-right: 0.75em;\n  }\n\n  .", " {\n    text-decoration: none;\n    color: ", ";\n    :hover {\n      text-decoration: underline;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  font-size: ", ";\n\n  .", " {\n    flex-shrink: 0;\n    flex-basis: ", "px;\n    margin-right: 0.75em;\n  }\n\n  .", " {\n    text-decoration: none;\n    color: ", ";\n    :hover {\n      text-decoration: underline;\n    }\n  }\n"])), polished_1.rem(16), pictureLinkClass, PICTURE_WIDTH, titleLinkClass, function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
});
var Detail = styled_components_1["default"]('div')(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject([""], [""])));
var Title = styled_components_1["default"]('div')(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  font-size: 1em;\n  margin: 0;\n  color: ", ";\n  text-decoration: none;\n  line-height: 1.3;\n  margin-bottom: 0.1em;\n"], ["\n  font-size: 1em;\n  margin: 0;\n  color: ", ";\n  text-decoration: none;\n  line-height: 1.3;\n  margin-bottom: 0.1em;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
});
var Subtitle = styled_components_1["default"]('p')(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  margin: 0;\n  font-size: 0.75em;\n  color: ", ";\n"], ["\n  margin: 0;\n  font-size: 0.75em;\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return polished_1.rgba(theme.app.textColor, 0.75);
});
var Picture = styled_components_1["default"](MediaManagerImage_1["default"])(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  min-width: ", "px;\n"], ["\n  min-width: ", "px;\n"])), PICTURE_WIDTH);

var ListItem = function (_a) {
  var article = _a.article,
      renderLink = _a.renderLink,
      showPicture = _a.showPicture;
  return react_1["default"].createElement(Wrapper, null, showPicture && renderLink({
    type: utilities_1.WIDGET_LINK_TYPE.ARTICLE_DETAIL,
    payload: article,
    linkProps: {
      className: pictureLinkClass,
      children: react_1["default"].createElement(Picture, {
        picture: article.picture,
        naturalWidth: PICTURE_WIDTH,
        naturalHeight: PICTURE_HEIGHT,
        script: "media"
      })
    }
  }), react_1["default"].createElement(Detail, null, renderLink({
    type: utilities_1.WIDGET_LINK_TYPE.ARTICLE_DETAIL,
    payload: article,
    linkProps: {
      className: titleLinkClass,
      children: react_1["default"].createElement(Title, null, article.name)
    }
  }), react_1["default"].createElement(Subtitle, null, utilities_1.getArticleMeta(article))));
};

ListItem.propTypes = {
  showPicture: prop_types_1["default"].bool,
  article: propTypes_1.ArticlePropType.isRequired
};
ListItem.defaultProps = {
  showPicture: true
};
exports["default"] = ListItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;